<div class="map-wrapper">
  <div class="map-container" #mapRef></div>

  <div class="panel" *ngIf="selectedFeatures.length">

    <button class="close-btn" (click)="closePanel()" aria-label="Close">
      &times;
    </button>

    <table class="feature-table">
      <thead>
        <tr>
          <th>Feature Type</th>
          <th>Feature Name</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let feature of selectedFeatures">
          <td>{{ toPascalCase(feature.featureType) }}</td>
          <td>
            <a href="" (click)="openFeature($event, feature)">
              {{ feature.gmlName }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</div>